/* Luxe iOS layer — tiny, additive, cannot block theme handlers.
   Ported from the Sam Mills iOS layer (ios-enhance.js). Never calls
   preventDefault / stopPropagation, every block is wrapped in try/catch. */

/* 1. Tap ripple on filled CTAs.
   The ripple goes in its own clipped layer, and only into buttons that are
   already positioned, so the theme's own layout and add-to-cart animation
   are never changed. */
(function () {
  'use strict';
  try {
    if (!document.body.classList.contains('luxe--tactile')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var SELECTOR =
      '.button:not(.button-unstyled, .button-custom), button.shopify-payment-button__button--unbranded, .luxe-ripple-btn';

    document.addEventListener(
      'pointerdown',
      function (event) {
        var target = event.target;
        var button = target && target.closest ? target.closest(SELECTOR) : null;
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        if (getComputedStyle(button).position === 'static') return;

        var rect = button.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);

        var layer = document.createElement('span');
        layer.className = 'luxe-ripple-layer';
        layer.setAttribute('aria-hidden', 'true');

        var ripple = document.createElement('span');
        ripple.className = 'luxe-ripple';
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = event.clientX - rect.left - size / 2 + 'px';
        ripple.style.top = event.clientY - rect.top - size / 2 + 'px';

        layer.appendChild(ripple);
        button.appendChild(layer);
        setTimeout(function () {
          if (layer.parentNode) layer.parentNode.removeChild(layer);
        }, 650);
      },
      { passive: true }
    );
  } catch (err) {
    /* silent — never break the store */
  }
})();

/* 2. Background videos keep playing.
   iOS refuses autoplay in Low Power Mode and some data-saver modes, and shows a
   play button over the hero. play() is retried on the first gesture and when the
   tab becomes visible again — moments the browser accepts. Only muted autoplay
   videos that are on screen and have NEVER started are touched: once a video has
   played, any later pause is the theme's (e.g. inactive layered-slideshow tabs). */
(function () {
  'use strict';
  try {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[autoplay]'));
    if (!videos.length) return;

    var started = new WeakSet();
    videos.forEach(function (video) {
      if (!video.paused) started.add(video);
      video.addEventListener('playing', function () {
        started.add(video);
      });
    });

    var tries = 0;
    var kick = function () {
      if (tries > 40) return;
      tries++;
      videos.forEach(function (video) {
        if (started.has(video) || !video.paused || !video.muted || !video.isConnected) return;
        if (!video.getClientRects().length) return; // hidden copy (e.g. desktop-only video on a phone)
        video.setAttribute('playsinline', '');
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
    };

    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (type) {
      document.addEventListener(type, kick, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
  } catch (err) {
    /* silent — never break the store */
  }
})();
